import { motion } from 'framer-motion';

export const AdmissionsTimeline = ({
  steps,
  sectionLabel = 'How to Apply',
  title = 'Admissions Process',
  description = 'The admissions process is designed to be clear and accessible.',
}) => (
  <section className="py-20 md:py-32">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="text-center mb-12 md:mb-16">
        <p className="text-sm font-medium uppercase tracking-widest text-[#163A59] mb-4">
          {sectionLabel}
        </p>
        <h2 className="font-['Source_Serif_4'] text-3xl md:text-4xl lg:text-5xl font-semibold text-slate-900 mb-6">
          {title}
        </h2>
        <p className="text-lg text-slate-600 max-w-2xl mx-auto">
          {description}
        </p>
      </div>

      <div className="max-w-4xl mx-auto">
        <div className="space-y-6">
          {steps.map((step, index) => (
            <motion.div
              key={step.step}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="flex gap-6"
            >
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-[#163A59] text-white flex items-center justify-center rounded-sm font-bold text-lg">
                  {step.step}
                </div>
                {index < steps.length - 1 && (
                  <div className="w-0.5 h-12 bg-slate-200 mx-auto mt-2"></div>
                )}
              </div>
              <div className="pt-2">
                <h3 className="font-semibold text-slate-900 mb-2">{step.title}</h3>
                <p className="text-slate-600">{step.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
